import { useCallback, useState } from "react";
import ProjectTeamRoleContributorsResponseResource from "common/resources/Project/Config/Team/Role/ProjectTeamRoleContributorsResponseResource";

export enum ERoleModal {
	ADD_CONTRIBUTOR = "ADD_CONTRIBUTOR",
	CREATE_ROLE = "CREATE_ROLE",
	EDIT_ROLE = "EDIT_ROLE",
	DELETE_ROLE = "DELETE_ROLE",
}

export const useRoleModal = () => {
	const [openedModal, setOpenedModal] = useState<ERoleModal | null>(null);
	const [selectedRole, setSelectedRole] = useState<ProjectTeamRoleContributorsResponseResource | null>(null);

	const isModalOpen = useCallback((modal: ERoleModal) => openedModal === modal, [openedModal]);

	const onCloseModal = useCallback(() => {
		setOpenedModal(null);
		setSelectedRole(null);
	}, []);

	const onOpenAddContributorModal = useCallback(
		(role: ProjectTeamRoleContributorsResponseResource) => {
			setOpenedModal(ERoleModal.ADD_CONTRIBUTOR);
			setSelectedRole(role);
		},
		[setOpenedModal],
	);

	const onOpenCreateRoleModal = useCallback(() => {
		setOpenedModal(ERoleModal.CREATE_ROLE);
	}, [setOpenedModal]);

	const onOpenEditRoleModal = useCallback(
		(role: ProjectTeamRoleContributorsResponseResource) => {
			setOpenedModal(ERoleModal.EDIT_ROLE);
			setSelectedRole(role);
		},
		[setOpenedModal],
	);

	const onOpenDeleteRoleModal = useCallback(
		(role: ProjectTeamRoleContributorsResponseResource) => {
			setOpenedModal(ERoleModal.DELETE_ROLE);
			setSelectedRole(role);
		},
		[setOpenedModal],
	);

	return { selectedRole, isModalOpen, onCloseModal, onOpenAddContributorModal, onOpenCreateRoleModal, onOpenEditRoleModal, onOpenDeleteRoleModal };
};
